<template>
    <asset-register-component-setup 
        :dialog="dialog" 
        :data="componentFormData" 
        @update:dialog="dialog = $event" 
    />  
    <v-window-item value="components">
        <v-card-text>
            <v-row>
                <v-col cols="12">
                    <div class="d-flex justify-space-between align-center mb-4">
                        <h2 class="text-h6">Asset Components</h2>
                        <v-btn
                            @click="openAssetComponent"
                            color="primary"
                            variant="tonal"
                            prepend-icon="mdi mdi-plus"
                            rounded="xl"
                        >
                            Add Asset Component
                        </v-btn>
                    </div>
                </v-col>
            </v-row>

            <v-row>
                <v-col cols="12" class="pa-1">
                    <v-data-table
                        :headers="compnentsHeaders"
                        :items="componentsData"
                        :loading="loading"
                        :hover="true"
                        density="compact"
                        elevation="0"
                        class="border-sm rounded-md"
                    >
                        <template v-slot:item.picture="{ item }">
                            <v-avatar size="48" rounded class="my-2">
                                <v-img :src="item.picture" :alt="item.name"></v-img>
                            </v-avatar>
                        </template>

                        <template v-slot:item.type="{ item }">
                            <v-chip :color="getComponentTypeColor(item.type)" size="small">
                                {{ item.type }}
                            </v-chip>
                        </template>

                        <template v-slot:item.available="{ item }">
                            <v-chip 
                                :color="item.available > 0 ? 'success' : 'error'" 
                                size="small"
                            >
                                {{ item.available }}
                            </v-chip>
                        </template>

                        <template v-slot:item.actions="{ item }">
                            <v-btn 
                                icon 
                                size="small" 
                                variant="text" 
                                color="orange"
                                @click="editComponent(item)"
                            >
                                <v-icon>mdi-pencil</v-icon>
                            </v-btn>
                        </template>
                    </v-data-table>
                </v-col>
            </v-row>
        </v-card-text>
    </v-window-item>
</template>

<script>
import assetRegisterComponentSetup from '@/components/module/asset/assetRegistration/assetRegisterComponents/assetRegisterComponentSetup.vue';

export default {
    props: {
        componentsData: {
            type: Array,
            default: () => []
        },
        loading: {
            type: Boolean,
        }
    },
    components: {
        assetRegisterComponentSetup
    },
    data: () => ({
        dialog: false,
        defaultImage: '/src/assets/no_preview.jpeg',
        previewImage: null,
        loading: false,
        componentFormData: {
            id: null,
            name: "",
            asset_register_id: null,
            brand_id: null,
            asset_status_id: null,
            unit_price: "",
            quantity: "",
            description: "",
            image: null,
        },
        compnentsHeaders: [
            { title: "#SL", align: "center", key: "id", width: "40px", sortable: false },
            { title: "Name", key: "name", align: "left", sortable: false },
            { title: "Code", key: "code", align: "center", sortable: true },
            { title: "Brand", key: "brand.name", align: "center", sortable: false },
            { title: "Quantity", key: "quantity", align: "end", sortable: true },
            { title: "Unit Price", key: "unit_price", align: "end", sortable: true },
            { title: "Total Price", key: "total_price", align: "end", sortable: true },
            { title: "Status", key: "asset_status.name", align: "center", sortable: false },
            { title: "Action", key: "actions", align: "center", sortable: false },
        ],
    }),
    computed: {},
    watch: {},
    created() {},
    methods: {
        openAssetComponent() {
            this.componentFormData = {
                id: null,
                name: "",
                asset_register_id: null,
                brand_id: null,
                asset_status_id: null,
                unit_price: "",
                quantity: "",
                description: "",
                image: null,
            };
            this.dialog = true;
        },
        editComponent(item) {
            this.componentFormData = { ...item };
            this.dialog = true;
        },
    },
    setup(props, {emit}){
        
    },
    mounted() {
        
    },
}
</script>